// extracted by mini-css-extract-plugin
export default {"InputYAnchor":"InputYAnchor_InputYAnchor__z83d3"};